import Axios from 'axios'
import qs from 'qs'
import request from "@/utils/request";

const upload = function (file, dir = '', override = false) {
    return new Promise((resolve, reject) => {
        const url = '/upload/policy' + (override ? '/override' : '')
        request({
            url: url + '?' + qs.stringify({dir: dir, filename: file.name}),
            method: 'POST'
        })
            .then(res => {
                const formData = new FormData()
                formData.append('name', file.name)
                formData.append('key', res.key)
                formData.append('policy', res.policy)
                formData.append('OSSAccessKeyId', res.accessid)
                formData.append('success_action_status', '200')
                formData.append('callback', res.callback)
                formData.append('signature', res.signature)
                formData.append('Content-Disposition', `attachment; filename=${encodeURIComponent(file.name)}`);
                formData.append('file', file)
                Axios.create()
                    .post(res.uploadUrl, formData)
                    .then(ossRes => {
                        if (ossRes.data && ossRes.data.Status === 'OK') {
                            resolve(res.downloadUrl)
                        } else {
                            reject('upload failed.')
                        }
                    })
                    .catch(err => reject(err))
            })
            .catch(err => reject(err))
    })
}

export {upload}
